import { get, getAll } from '@bigyouth/base'
import withScroll from '../hoc/withScroll'
import instantsearch from 'instantsearch.js'
import algoliasearch from 'algoliasearch/lite'
import trainingSearch from '../utils/Lists/trainingSearch'

import customHits from '../utils/Lists/customHits'
import customHitsInner from '../utils/Lists/customHitsInner'
import customPagination from '../utils/Lists/customPagination'
import customStats from '../utils/Lists/customStats'
import customClear from '../utils/Lists/customClear'
import customCurrentRefinements from '../utils/Lists/customCurrentRefinements'
import customRefinementList from '../utils/Lists/customRefinementList'
import customSortBy from '../utils/Lists/customSortBy'
import customCalendar from '../utils/Lists/customCalendar'
import customMenu from '../utils/Lists/customMenu'
import customMenuSelect from '../utils/Lists/customMenuSelect'
import customClearSubTheme from '../utils/Lists/customClearSubTheme'

import { configure, searchBox } from 'instantsearch.js/es/widgets'

export default withScroll({
  name: 'training-list',

  currentTheme: null,
  themesIndex: {},
  themeInUrl: null,

  ui: {
    results: '[js-training-list-results]',
    innerResults: '[js-training-list-inner-results]',
    'numberTrainings[]': '[js-training-list-number-trainings]',
    pagination: '[js-training-list-pagination]',
    stats: '[js-training-list-stats]',
    searchBox: '[js-training-list-searchbox]',
    suggestions: '[js-training-list-suggestions]',
    suggestionsWrap: '[js-training-list-suggestions-wrap]',
    clear: '[js-training-list-clear]',
    clearMobile: '[js-training-list-clear-mobile]',
    actives: '[js-training-list-actives]',
    currentFilters: '[js-training-list-current]',
    daysCount: '[js-training-list-days-count]',
    certifs: '[js-training-list-certifs]',
    'panels[]': '[js-training-list-panel]',
    'panelsLevel1[]': '[js-training-list-panel-level1]',
    'togglePanel[]': '[js-training-list-toggle-panel]',
    'closeFilters[]': '[js-training-list-close-filters]',
    'backFilters[]': '[js-training-list-back-filters]',
    backSubthemes: '[js-training-list-back-subthemes]',
    themes: '[js-training-list-themes]',
    subthemes: '[js-training-list-subthemes]',
    modality: '[js-training-list-modality]',
    'currentTheme[]': '[js-training-list-current-theme]',
    currentSubtheme: '[js-training-list-current-subtheme]',
    currentSubthemeCount: '[js-training-list-current-subtheme-count]',
    sort: '[js-training-list-sort]',
    rangeDate: '[js-training-list-range-date]',
    rangeDateSingle: '[js-training-list-range-date-single]',
    intro: '[js-training-list-intro]',
    mobileBar: '[js-training-list-mobile-bar]',
    clearSubtheme: '[js-training-list-clear-subtheme]',
    refine: '[js-training-list-refine]',
  },

  getInitialFilters () {
    try {
      const filtersData = this.el.dataset.initialFilters
      console.log('Initial filters data:', filtersData)
      return filtersData ? JSON.parse(filtersData) : null
    } catch (e) {
      console.warn('Failed to parse initial filters:', e)
      return null
    }
  },

  convertFiltersToUiState (filters) {
    const uiState = {}

    console.log('Converting filters to UI state:', filters)

    // Handle theme filter from {env}_pages_date[menu][themes.name]
    // Find the key that ends with '_pages_date'
    const pagesDateKey = Object.keys(filters).find(key => key.endsWith('_pages_date'))

    console.log('Found pages date key:', pagesDateKey)

    if (pagesDateKey && filters[pagesDateKey] && filters[pagesDateKey].menu && filters[pagesDateKey].menu['themes.name']) {
      uiState.menu = {
        'themes.name': filters[pagesDateKey].menu['themes.name'],
      }
      console.log('Setting theme filter:', filters[pagesDateKey].menu['themes.name'])
    }

    console.log('Final UI state:', uiState)
    return uiState
  },

  events: [
    {
      on: 'click',
      target: 'togglePanel',
      handle ({ target }) {
        get(`[js-training-list-panel][data-panel="${target.dataset.panel}"]`).classList.add('is-visible')
      },
    },
    {
      on: 'click',
      target: 'refine',
      handle ({ target }) {
        this.saveCurrentSearchState()
        get('[js-training-list-panel][data-panel="subthemes"]').classList.remove('is-visible')
      },
    },
    {
      on: 'click',
      target: 'backSubthemes',
      handle ({ target }) {
        get('[js-training-list-panel][data-panel="trainings"]').classList.remove('is-visible')
      },
    },
    {
      on: 'click',
      target: 'closeFilters',
      handle ({ target }) {
        // reset search to previous state since apply was not hit
        if (target.classList.contains('filters__close-button')) {
          this.ui.clear.querySelector('button').click()

          trainingSearch.applyFilters(this.search, this.currentSearchState)
        }

        setTimeout(() => {
          this.ui.panelsLevel1.forEach((panel) =>
            panel.classList.remove('is-visible'),
          )
        }, 600)
      },
    },
    {
      on: 'click',
      target: 'backFilters',
      handle () {
        getAll('[js-training-list-panel].is-visible').forEach((panel) =>
          panel.classList.remove('is-visible'),
        )
      },
    },
  ],

  componentDidMount () {
    const indexName = `${config.algolia.env}_pages`

    const searchClient = algoliasearch(
      process.env.ALGOLIA_APP_ID,
      process.env.ALGOLIA_API_KEY,
    )

    // Get initial filters from the template data attribute
    const initialFilters = this.getInitialFilters()

    this.search = instantsearch({
      indexName: `${indexName}_date`,
      searchClient: searchClient,
      initialUiState: initialFilters
        ? {
            [`${indexName}_date`]: this.convertFiltersToUiState(initialFilters),
          }
        : undefined,
      routing: {
        stateMapping: {
          stateToRoute (uiState) {
            const indexUiState = uiState[`${indexName}_date`]

            return {
              query: indexUiState.query && indexUiState.query,
            }
          },
          routeToState (routeState) {
            return {
              [indexName]: {
                query: routeState.query,
              },
            }
          },
        },
      },
    })

    const index = searchClient.initIndex(indexName)

    index
      .search('', {
        hitsPerPage: 1000,
        filters: 'status:published AND type:formation AND price_ht > 0',
        attributesToRetrieve: ['themes'],
      })
      .then(({ hits }) => {
        hits.forEach((hit) => {
          hit.themes.forEach((theme) => {
            if (this.themesIndex[theme.name] === undefined) {
              this.themesIndex[theme.name] = []
            }

            theme.subTheme.forEach(subTheme => {
              if (!this.themesIndex[theme.name].includes(subTheme.name)) {
                this.themesIndex[theme.name].push(subTheme.name.trim())
              }
            })
          })
        })
      })

    this.search.on('render', () => {
      const keyword = this.search.renderState[this.search.indexName].searchBox.query
      if (keyword.length > 0) {
        console.log('Sending tracking to Matomo : ', keyword)
        _paq.push(['setCustomUrl', '/formations?query=' + encodeURIComponent(keyword)])
        _paq.push(['trackPageView'])
      }
    })

    this.search.addWidgets([
      // global
      configure({
        hitsPerPage: 12,
        queryLanguages: ['fr'],
        ignorePlurals: true,
        filters: 'status:published AND type:formation AND price_ht > 0',
      }),
      // results
      customHits({
        container: this.ui.results,
      }),
      // results in theme end tunnel
      customHitsInner({
        container: this.ui.innerResults,
      }),
      // searchbox at top
      searchBox({
        container: this.ui.searchBox,
        placeholder: 'Rechercher par mots clés, référence, thèmes...',
        searchAsYouType: false,
      }),
      // for period
      customCalendar({
        container: this.ui.rangeDate,
        attribute: 'courses.startDate',
        rangeDateSingle: this.ui.rangeDateSingle,
        minDate: true,
      }),
      // current refinements list
      customCurrentRefinements({
        container: this.ui.currentFilters,
        currentTheme: this.ui.currentTheme,
        currentSubtheme: this.ui.currentSubtheme,
        currentSubthemeCount: this.ui.currentSubthemeCount,
        suggestionsWrap: this.ui.suggestionsWrap,
        actives: this.ui.actives,
      }),
      // sort
      customSortBy({
        container: this.ui.sort,
        items: [
          { label: 'Date', value: `${indexName}_date` },
          { label: 'Pertinence', value: indexName },
          { label: 'Nouveauté', value: `${indexName}_new` },
        ],
      }),
      // list of init suggestions
      customMenu({
        container: this.ui.suggestions,
        suggestionsWrap: this.ui.suggestionsWrap,
        attribute: 'themes.name',
        limit: 5,
        sortBy: ['count:desc'],
      }),
      // theme choice
      customMenuSelect({
        container: this.ui.themes,
        attribute: 'themes.name',
        limit: 50,
        themesIndex: this.themesIndex,
      }),
      // subtheme choice
      customMenuSelect({
        container: this.ui.subthemes,
        attribute: 'themes.subTheme.name',
        limit: 50,
        themesIndex: this.themesIndex,
      }),
      // stats : in title, buttons etc
      customStats({
        container: this.ui.stats,
        type: 'training',
        pagination: this.ui.pagination,
        numberItems: this.ui.numberTrainings,
        nbHitsPerPage: 12,
      }),
      // clear all refinements
      customClear({
        container: this.ui.clear,
      }),
      // clear all refinements mobile
      customClear({
        container: this.ui.clearMobile,
      }),
      // clear all refinements mobile
      customClearSubTheme({
        container: this.ui.clearSubtheme,
        includedAttributes: ['themes.subTheme.name'],
      }),
      // days count refinement
      customRefinementList({
        container: this.ui.daysCount,
        attribute: 'daysCount',
        sortBy: ['label:asc'],
        transformItems (items) {
          const daysCountLabels = {
            1: "Jusqu'à 1 jour",
            2: 'Entre 1 et 2 jours',
            '2+': '+ de 2 jours',
          }

          return items.map((item) => ({
            ...item,
            label: daysCountLabels[item.label],
          }))
        },
      }),
      // certifs refinement
      customRefinementList({
        container: this.ui.certifs,
        attribute: 'training_diploma',
        sortBy: ['label:asc'],
      }),
      // modality refinement
      customRefinementList({
        container: this.ui.modality,
        attribute: 'training_modality',
        sortBy: ['label:desc'],
      }),
      // pagination
      customPagination({
        container: this.ui.pagination,
        padding: window.innerWidth < 768 ? 1 : 2,
      }),
    ])

    this.search.start()
  },

  onScroll ({ y }) {
    // mobile fixed search bar
    if (window.innerWidth < 768) {
      if (y > this.ui.intro.offsetTop + this.ui.intro.offsetHeight) {
        this.ui.mobileBar.classList.add('is-sticky')
      } else {
        this.ui.mobileBar.classList.remove('is-sticky')
      }
    }
  },

  saveCurrentSearchState () {
    this.currentSearchState = this.search.renderState[`${this.search.indexName}`].currentRefinements.items

    // display keyword in popin filters
    const searchbox = this.search.renderState[`${this.search.indexName}`].searchBox.query
    const keywordDisplay = get('[js-training-list-keyword]')

    keywordDisplay.innerHTML = searchbox

    if (searchbox !== '') {
      keywordDisplay.parentNode.classList.remove('hidden')
    } else {
      keywordDisplay.parentNode.classList.add('hidden')
    }
  },
})
